module.exports = __webpack_public_path__ + "static/media/pic_banner_partners.73cdf3d8.jpg";